import type { SceneArt } from '../data/cutscenes'
import { dioramaArt } from './DioramaArt'

export interface DioramaSkyboxLock {
  scene: SceneArt
  color: number
  /** Keep the atmospheric veil tied to the same authored environment as the horizon. */
  fogDensity: number
}

/** Keep the visible horizon and atmospheric veil deterministic for one cutscene. Shot-specific
 * lighting and set dressing can still change, but the empty space behind the miniature cannot jump
 * when the screenplay cuts to another camera or location plate. */
export function lockDioramaSkybox(previous: SceneArt | null, next: SceneArt): DioramaSkyboxLock {
  const scene = previous ?? next
  return { scene, color: dioramaArt(scene).haze, fogDensity: dioramaArt(scene).fogDensity }
}
